export default "__VITE_ASSET__Cwf55w4q__"